import { Instance, types } from "mobx-state-tree";
import { withSetPropAction } from "@/models/helpers/withSetPropAction";

/**
 * 
 * 商品分堆
 * 
 */
export const VenderStoreModel = types
  .model("VenderStore")
  .props({
    
  })
  .views((self) => ({
    
  }))
  .actions(withSetPropAction)
  .actions((self: any) => ({
    
  }));

export interface VenderStoreModel extends Instance<typeof VenderStoreModel> { }
